import type { DataFunctionArgs } from '@modules/root';
import { getRecentlyViewedArticles } from '~/modules/articles/api/get-recently-viewed-articles.server';

export interface LoaderResult {
    recentlyViewedArticles: Awaited<
        ReturnType<typeof getRecentlyViewedArticles>
    >;
}

export const loader: ({
    context,
}: DataFunctionArgs) => Promise<LoaderResult | null> = async ({ context }) => {
    const [recentlyViewedArticles] = await Promise.all([
        getRecentlyViewedArticles(context),
    ]);

    return {
        recentlyViewedArticles,
    };
};

export const HREF_RECENTLY_VIEWED_ARTICLES =
    '/remix-api/articles/get-recently-viewed-articles';
